// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main." + "5f3673e873884716148f" + ".js";
};